import { ErrorModalTypes } from '@Store/index';
import { IErrorHandling, OnboardingFormFields } from '@Types/index';
import { Icons } from '@Components/icon/Icon.tsx';

export const GeneralErrorMap = {
  INCORRECT_STATE: 4012,
  CUSTOMER_ALREADY_REGISTER: 4035,
};

export const GeneralErrorMapObject = new Map<number, IErrorHandling>([
  [
    GeneralErrorMap.CUSTOMER_ALREADY_REGISTER,
    {
      errorCode: GeneralErrorMap.CUSTOMER_ALREADY_REGISTER,
      redirectPath: OnboardingFormFields.EMAIL,
      relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
      callBack: () => {},
    },
  ],

  [
    GeneralErrorMap.INCORRECT_STATE,
    {
      errorCode: GeneralErrorMap.INCORRECT_STATE,
      redirectPath: '',
      relatedFieldName: OnboardingFormFields.GENERIC_ERROR_FIELD,
      callBack: () => {},
      openModal: true,
      modalProps: {
        type: ErrorModalTypes.GENERAL,
        title: 'User in incorrect state',
        content: 'There is a problem with your user. Please contact support .',
        icon: Icons.Oops,
        buttonText: 'OK',
      },
    },
  ],
]);
